import { useState, useEffect } from "react";

// Function to detect if the device is mobile
const useDevice = () => {
  const [isMobile, setIsMobile] = useState<boolean>(window.innerWidth <= 1024); // 768px is a common breakpoint for mobile

  const handleResize = () => {
    setIsMobile(window.innerWidth <= 768); // Adjust this value based on your design's mobile breakpoint
  };

  useEffect(() => {
    window.addEventListener("resize", handleResize);

    // Cleanup on unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []); 

  return isMobile;
};

export default useDevice;